function getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}

function getAvatar (vm) {
  const { avatar } = vm.$options
  if (avatar) {
    return typeof avatar === 'function'
      ? avatar.call(vm)
      : avatar
  }
}

function get_og_title (vm) {
  const { og_title } = vm.$options
  if (og_title) {
    return typeof og_title === 'function'
      ? og_title.call(vm)
      : og_title
  }
}

function get_og_image (vm) {
  const { og_image } = vm.$options
  if (og_image) {
    return typeof og_image === 'function'
      ? og_image.call(vm)
      : og_image
  }
}

const serverTitleMixin = {
  created () {
    const title = getTitle(this)
    if (title) {
      this.$ssrContext.title = `${title} | LMK - Make New Friends`
    }
    const avatar = getAvatar(this)
    if (avatar) {
      this.$ssrContext.avatar = avatar
    }
    const og_title = get_og_title(this)
    if (og_title) {
      this.$ssrContext.og_title = og_title
    }
    const og_image = get_og_image(this)
    if (og_image) {
      this.$ssrContext.og_image = og_image
    }
  }
}

const clientTitleMixin = {
  mounted () {
    const title = getTitle(this)
    if (title) {
      document.title = `${title} | LMK - Make New Friends`
    }

    // const avatar = getAvatar(this)
    // if (avatar) {
    //   document.avatar = avatar
    // }

    // const og_title = get_og_title(this)
    // if (og_title) {
    //   document.querySelector('meta[property="og:title"]').setAttribute('content', og_title);
    // }
    // const og_image = get_og_image(this)
    // if (og_image) {
    //   document.querySelector('meta[property="og:image"]').setAttribute('content', og_image);
    // }
  }
}

export default process.env.VUE_ENV === 'server'
  ? serverTitleMixin
  : clientTitleMixin



// WEBPACK FOOTER //
// src/util/title.js